import { showLoader, hideLoader } from '../../../Shared/Loader';
import { Ajax } from '../../../components/Ajax';
import { ApiUrl } from '../../../project/Defines';
import { message } from 'antd';
import FileSaver from 'file-saver';

const ExportLoaderName = 'EXPORT_LOADER';

export function StatisticsExport(data, isThercodim = false) {
	showLoader(ExportLoaderName);

	Ajax.download({
		url: isThercodim ? ApiUrl.ThercodimStatisticsExport : ApiUrl.StatisticsExport,
		data: data,
		//autoDownload: false,
		success: (blob) => {
			FileSaver.saveAs(blob, "Statistics.xlsx");
			hideLoader(ExportLoaderName);
		},
		error: () => {
			hideLoader(ExportLoaderName);
            message.error("Error API.");
		}
	});
}


export function StudiesExport(data) {
	showLoader(ExportLoaderName);

	Ajax.download({
		url: ApiUrl.StudiesExport,
		data: data,
		//autoDownload: false,
		success: (blob) => {
			FileSaver.saveAs(blob, "Studies.xlsx");
			hideLoader(ExportLoaderName);
		},
		error: () => {
			hideLoader(ExportLoaderName);
            message.error("Error API.");
		}
	});
}